<template>
  <div>
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="0">
      <!-- 相关申请选择(二选一) -->
      <div v-if="applymentDetail.businessType == 'COMPANY_INCORPORATION'">
        <p class="pt40 mustTitle">
          {{ $t("enroll.affirm.correlationTitle") }}
        </p>
        <div class="pt16 checkWrap">
          <el-form-item prop="extraInfo.apply" ref="extraInfo.apply" class="mb0">
            <el-radio-group v-model="dataForm.extraInfo.apply" :disabled="disabled">
              <el-radio :label="2">{{ $t("enroll.affirm.correlationOption01") }}</el-radio>
              <el-radio :label="1" class="pt12">{{ $t("enroll.affirm.correlationOption02", { supplierName: applymentSupplierNameStr }) }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>

      <!-- 协议签署 -->
      <p class="pt60 mustTitle">{{ $t("enroll.affirm.agreementTitle") }}</p>
      <div class="pt16 yesWrap">
        <!-- 我已经阅读服务协议附件 -->
        <el-form-item prop="extraInfo.haveRead" ref="extraInfo.haveRead" class="mb10 pr20 haveWrap">
          <el-checkbox v-model="dataForm.extraInfo.haveRead" :disabled="disabled" class="agreementWrap">
            <span class="fs14">{{ $t("enroll.affirm.correlationAlready") }}</span>
          </el-checkbox>

          <!-- 名义董事协议 -->
          <template v-if="applymentHasNomineeDirector || (applymentDetail.businessType == 'COMPREHENSIVE_CUSTOMIZED' && applymentDetail.hasNomineeDirector)">
            <span v-for="(item, index) in directorProtocolUrls" :key="`directorProtocol-${index}`">
              <a :href="item.url" :download="$t('enroll.affirm.correlationDownload')" target="_" class="fs14 black88 crp agreement" v-if="item.url">
                {{ $t("enroll.affirm.correlationDownload") }}{{ item.supplierName }}
              </a>
            </span>
          </template>

          <!-- EP申请协议 -->
          <template v-if="applymentDetail.businessType == 'COMPANY_INCORPORATION' && applymentHasEPApplication">
            <span v-for="(item, index) in EPProtocolUrls" :key="`EPProtocol-${index}`">
              <a :href="item.url" :download="$t('enroll.affirm.EPApplicationDownload')" target="_" class="fs14 black88 agreement" v-if="item.url">
                {{ $t("enroll.affirm.EPApplicationDownload") }}{{ item.supplierName }}
              </a>
            </span>
          </template>

          <!-- 服务协议(公司类) -->
          <template v-if="applymentDetail.businessGenre == 'COMPANY'">
            <span v-for="(item, index) in companyServiceProtocolUrls" :key="`companyServiceProtocol-${index}`">
              <a :href="item.url" :download="$t('enroll.affirm.correlationCheck')" target="_" class="fs14 black88 ml6 agreement" v-if="item.url">
                {{ $t("enroll.affirm.correlationCheck") }}{{ item.supplierName }}
              </a>
            </span>
          </template>

          <!-- 服务协议(基金类) -->
          <template v-if="applymentDetail.businessGenre == 'FUND'">
            <span v-for="(item, index) in fundServiceProtocolUrls" :key="`fundServiceProtocol-${index}`">
              <a :href="item.url" :download="$t('enroll.affirm.engagementLetter')" target="_" class="fs14 black88 crp ml6 agreement" v-if="item.url">
                {{ $t("enroll.affirm.correlationCheck") }}{{ item.supplierName }}
              </a>
            </span>
          </template>

          <!-- 收费协议  -->
          <template v-if="applymentDetail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || applymentDetail.businessType == 'FUND_ADMIN_CUSTOMIZED'">
            <span class="crp fs14 black88 crp ml6 agreement" @click="toFeeLetterLink">
              {{ $t("enroll.affirm.feeLetter") }}
            </span>
          </template>
        </el-form-item>

        <!-- 同意服务协议 -->
        <el-form-item prop="extraInfo.service" ref="extraInfo.service" class="mb10 pr20 haveWrap">
          <el-checkbox v-model="dataForm.extraInfo.service" :disabled="disabled">
            <span class="fs14 feed">{{ $t("enroll.affirm.consentOption01") }}</span>
            <br />
            <span class="fs12 black88 feed">
              {{ $t("enroll.affirm.consentOption02", { supplierNameAndAbbr: applymentSupplierNameAndAbbrStr, supplierAbbr: applymentSupplierAbbrStr }) }}
            </span>
          </el-checkbox>
        </el-form-item>

        <!-- 申请人声明 -->
        <el-form-item prop="extraInfo.statement" ref="extraInfo.statement" class="mb10 pr20 haveWrap">
          <el-checkbox v-model="dataForm.extraInfo.statement" :disabled="disabled">
            <span class="fs14 feed">{{ $t("enroll.affirm.statementOption01") }}</span>
            <br />
            <span class="fs12 black88 feed">{{ $t("enroll.affirm.statementOption02") }}</span>
          </el-checkbox>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getAction } from "@/api/common";
import { validateLocation } from "@/utils/common";
import validatorMixin from "@/mixins/validatorMixin";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  mixins: [validatorMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    // CRM后台用户令牌(前台用户无)
    voucher: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataForm: {
        extraInfo: {
          apply: 1,
          haveRead: false,
          service: false,
          statement: false,
        },
      },
      dataRule: {
        "extraInfo.apply": [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        "extraInfo.haveRead": [
          {
            required: true,
            validator: this.validateMustCheckbox,
            trigger: "submit",
          },
        ],
        "extraInfo.service": [
          {
            required: true,
            validator: this.validateMustCheckbox,
            trigger: "submit",
          },
        ],
        "extraInfo.statement": [
          {
            required: true,
            validator: this.validateMustCheckbox,
            trigger: "submit",
          },
        ],
      },
      directorProtocolUrls: [],
      companyServiceProtocolUrls: [],
      fundServiceProtocolUrls: [],
      EPProtocolUrls: [],
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail", "applymentSupplierList", "applymentHasNomineeDirector", "applymentHasEPApplication"]),
    ...mapGetters("language", ["getLanguage"]),
    // 申请单关联供应商的名称和简写
    applymentSupplierNameAndAbbrStr() {
      const list = [];
      this.applymentSupplierList.forEach(item => {
        let str = "";
        if (this.getLanguage == "zh") {
          str = `${item.companyName} (简称"${item.abbr}")`;
        } else {
          str = `${item.companyName} ("${item.abbr}") `;
        }
        list.push(str);
      });
      return list.join(", ");
    },
    // 申请单关联供应商的名称
    applymentSupplierNameStr() {
      const list = this.applymentSupplierList.map(item => item.companyName);
      return list.join(", ");
    },
    // 申请单关联供应商的简写
    applymentSupplierAbbrStr() {
      const list = this.applymentSupplierList.map(item => item.abbr);
      return list.join(", ");
    },
  },
  methods: {
    ...mapActions("applyment", ["fetchApplymentSupplierList"]),
    // 初始化
    async init() {
      // 回显
      const applymentDetailCopy = JSON.parse(JSON.stringify(this.applymentDetail));
      const { apply = 1, haveRead = false, service = false, statement = false } = applymentDetailCopy.extraInfo || {};
      this.dataForm = {
        extraInfo: {
          apply,
          haveRead,
          service,
          statement,
        },
      };
      // 获取申请单关联供应商列表
      await this.fetchApplymentSupplierList();
      // 获取协议URL
      this.getProtocolUrl();
    },
    // 获取协议URL
    getProtocolUrl() {
      return new Promise((resolve, reject) => {
        const supplierIds = this.applymentSupplierList.map(item => item.id);
        getAction("/stProtocol/getList", {
          supplierIds,
        })
          .then(res => {
            const resData = res.data || [];
            resData.forEach(item => {
              if (item.status == 1) {
                const supplier = this.applymentSupplierList.find(s => s.id == item.supplierId);
                const obj = {
                  type: item.type,
                  supplierName: supplier?.abbr ? `(${supplier.abbr})` : "",
                  url: this.getLanguage == "zh" ? item.fileUrlCn?.url : item.fileUrl?.url,
                };
                if (obj.type == "NOMINEE_DIRECTOR_AGREEMENT") {
                  this.directorProtocolUrls.push(obj);
                } else if (obj.type == "SERVICE_AGREEMENT") {
                  this.companyServiceProtocolUrls.push(obj);
                } else if (obj.type == "ENGAGEMENT_LETTER") {
                  this.fundServiceProtocolUrls.push(obj);
                } else if (obj.type == "EP_SERVICE_AGREEMENT") {
                  this.EPProtocolUrls.push(obj);
                }
              }
            });
            resolve(resData);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 跳转到收费协议页(定制化服务)
    toFeeLetterLink() {
      const query = { id: this.applymentDetail.id, lang: this.getLanguage };
      // 存在后台令牌时携带，供feeLetter页面走后台专用接口
      if (this.voucher) {
        query.voucher = this.voucher;
      }
      let routeUrl = this.$router.resolve({
        path: "/feeLetter",
        query,
      });
      window.open(routeUrl.href, "_blank");
    },
    // 获取提交参数(由父级触发)
    getParamsData() {
      return this.dataForm;
    },
    // 提交表单(由父级触发)
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            resolve();
          } else {
            validateLocation(object, this);
            reject("custom prompt: Form verification failed");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mustTitle {
  border-radius: 2px;
  font-size: 16px;
  line-height: 1em;
  font-weight: 600;
}

.mustTitle:before {
  content: "*";
  margin-right: 4px;
  color: #f56c6c;
}

.checkWrap {
  ::v-deep {
    .el-radio__label {
      display: inline-block;
      white-space: initial;
      line-height: 20px;
    }

    .el-radio__input {
      vertical-align: top;
      margin-top: 3px;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }

    .el-radio.is-disabled {
      .el-radio__label {
        color: #667288 !important;
      }
    }

    .el-radio.is-disabled.is-checked {
      .el-radio__inner {
        border-color: #0060ff !important;
        background: #0060ff !important;
      }
      .el-radio__label {
        color: #0060ff !important;
      }
    }
  }
}

.haveWrap {
  ::v-deep {
    .el-form-item__content {
      line-height: 30px;
    }

    .el-form-item__error {
      top: 76%;
      margin-left: 25px;
    }
  }
}

.yesWrap {
  ::v-deep {
    .el-checkbox__input {
      vertical-align: top;
      line-height: 0;
      padding-top: 3px;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }

    .el-checkbox__input.is-disabled.is-checked {
      .el-checkbox__inner {
        background-color: #0060ff !important;
        border-color: #0060ff !important;
      }
    }
  }
}

.agreementWrap {
  ::v-deep {
    .el-checkbox__input {
      vertical-align: middle !important;
      padding-top: 0px !important;
      margin-top: -2px !important;
    }
  }
}

.agreement {
  color: #0000cd;
  margin-left: 6px;
  text-decoration: underline;
}
</style>
